export const parseId = (id: string): number => {
  try {
    const idAtob = window.atob(id)
    return Number(idAtob.split(':')[1]) || 0
  } catch (error) {
    return 0
  }
}
export const parsePrice = (numStr: string) => {
  const num = Number(numStr)

  if (!num) return '$0.00'
  if (num === 0) return '$0.00'

  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(num)
}

const parsePriceToNum = (numStr: string) => {
  // const str = window.localStorage.getItem('money')
  // const locale = str ? JSON.parse(str)?.locale : 'es-CO'
  // if (commaDecimalPointThousands[locale]) {
  const res = numStr.replace(/\./g, '').replace(/,/, '.')
  return res
  // }
  /* if (pointDecimalCommaThousands[locale]) {
    const res = numStr.replace(/,/g, '')
    return res
  } */
  // return numStr
}

export interface IResDataToFrom {
  formId: number
  sections: {sectionId: number; response: {name: string; value: string}[]}[]
}

export const getFormParse = (obj: {[key: string]: string}): IResDataToFrom[] => {
  const REGEX = /^(?=.*[.,€])(?:[.,\d$€ ]+)$/
  const arrayFinal: IResDataToFrom[] = []
  Object.keys(obj).forEach((clave) => {
    const [formId, sectionId, name] = clave.split('-')
    const value = obj[clave]
    if (sectionId == null || name == null) return
    // Buscamos si ya existe un elemento con el mismo formId en el arrayFinal
    const formIndex = arrayFinal.findIndex((item) => item.formId === Number(formId))

    if (formIndex !== -1) {
      // Si existe, buscamos si ya existe una sección con el mismo sectionId
      const sectionIndex = arrayFinal[formIndex].sections.findIndex(
        (section) => section.sectionId === Number(sectionId)
      )

      if (sectionIndex !== -1) {
        // Si existe, agregamos la respuesta a esa sección
        arrayFinal[formIndex].sections[sectionIndex].response.push({
          name,
          value: REGEX.test(value) ? parsePriceToNum(value.replace(/[^,\d.]/g, '')) : value,
        })
      } else {
        // Si no existe, creamos la sección con la respuesta
        arrayFinal[formIndex].sections.push({
          sectionId: Number(sectionId),
          response: [
            {
              name,
              value: REGEX.test(value) ? parsePriceToNum(value.replace(/[^,\d.]/g, '')) : value,
            },
          ],
        })
      }
    } else {
      // Si no existe, creamos el elemento con el formId y la sección con la respuesta
      arrayFinal.push({
        formId: Number(formId),
        sections: [
          {
            sectionId: Number(sectionId),
            response: [
              {
                name,
                value: REGEX.test(value) ? parsePriceToNum(value.replace(/[^,\d.]/g, '')) : value,
              },
            ],
          },
        ],
      })
    }
  })
  return arrayFinal
}

export const includeConector = (words: string): string => {
  const [first, ...restWords] = words.split(' ')
  return `${first} de ${restWords.join(' ')}`
}

export const hasPermission = (permissions: string[], permissionName: string) => {
  if (!permissions) return false
  return permissions.some((permission) => permission === permissionName)
}

export const handleUpdateApp = (onLoading: (bool: boolean) => void) => {
  if ('serviceWorker' in window.navigator) {
    onLoading(true)
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const registration of registrations) {
        registration.unregister()
      }
      // eslint-disable-next-line no-undef
      caches.keys().then((kl) => {
        kl.forEach((key) => {
          // eslint-disable-next-line no-undef
          caches.delete(key)
        })
        /* NAMES_LOCALSTORAGE.forEach((name) =>
          window.localStorage.removeItem(name)
        ) */
        onLoading(false)
        window.location.reload()
      })
    })
  }
}
